import { useEffect, useState } from "react";
import { Button, Dialog, DialogTitle, Fade, Modal, Paper } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { ValidatorForm } from "react-material-ui-form-validator";
import PropTypes from "prop-types";
import PersonalData from "../Form/PersonalData";
import SystemDataCollection from "../Form/SystemDataCollection";
import SystemDataTreatment from "../Form/SystemDataTreatment";
import style from "./Forms.module.scss";
// import { getData } from "../Services/getData";
import { download, enumUrl } from "../Utils/utils";
import { getData } from "../Services/getData";

function FormsModal({ form, open, setForm, handleClose, handleSubmit }) {
  const [streets, setStreets] = useState(null);
  const [activeImage, setActiveImage] = useState(null);
  const [doc, setDoc] = useState({
    image: "",
    pdf: "",
  });

  useEffect(() => {
    if (!streets) getStreets();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**\
   *
   */
  useEffect(() => {
    if (doc.image === "" && doc.pdf === "") {
      const token = localStorage.getItem("access_token");
      const options = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      fetch(`${enumUrl.form}/${form._id}`, options)
        .then((response) => {
          if (response.status === 200) {
            if (response.headers.get("content-disposition"))
              response.blob().then((blob) => {
                setDoc({ ...doc, pdf: blob });
              });
            else
              response.text().then((text) => {
                setDoc({ ...doc, image: text });
              });
          }
        })
        .catch((err) => {
          //err
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form._id, open]);

  /**
   *
   */
  async function getStreets() {
    await getData(enumUrl.streets)
      .then((response) => {
        if (
          (response.status === 200 || response.status === 201) &&
          response.data
        ) {
          let tableData = [];
          response.data.forEach((street, index) => {
            tableData.push({
              id: index,
              label: street.street,
            });
          });
          setStreets(tableData);
        }
      })
      .catch((err) => {
        //err
      });
  }

  /**
   *
   * @param {*} e
   */
  function downloadPdf(e) {
    e.preventDefault();
    e.stopPropagation();
    const fileName = form.document.replace("./documents/", "");
    download(doc.pdf, fileName);
  }

  return (
    <Dialog
      onClose={handleClose}
      open={open}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: "1100px",
          },
        },
      }}
      style={{ marginTop: 70 }}
    >
      <DialogTitle
        style={{
          alignItems: "center",
          justifyContent: "center",
          display: "flex",
          margin: 10,
        }}
      >
        <p style={{ margin: 10, fontSize: "26px" }}>
          {form ? form.personalData.fullName : ""}
        </p>
        <p
          style={{
            position: "absolute",
            right: 40,
          }}
        >
          <CloseIcon
            onClick={handleClose}
            style={{ cursor: "pointer", fontSize: 28 }}
          />
        </p>
      </DialogTitle>
      <ValidatorForm
        onSubmit={handleSubmit}
        style={{ margin: "20px 0px 20px 40px" }}
      >
        <div className={style.formContent}>
          <PersonalData
            isModal={true}
            person={form.person}
            form={form}
            setForm={setForm}
            streets={streets}
          />
          <SystemDataCollection isModal={true} form={form} setForm={setForm} />
          <SystemDataTreatment isModal={true} form={form} setForm={setForm} />
          {doc.image ? (
            <div
              style={{ textAlign: "center" }}
              onClick={() => setActiveImage(doc.image)}
            >
              <img
                src={doc.image}
                alt="Document"
                style={{ height: 250, margin: 10 }}
              />
            </div>
          ) : (
            ""
          )}
          {doc.pdf ? (
            <a
              style={{ textDecoration: "none", color: "black", margin: 15 }}
              href={form.document}
              onClick={(e) => downloadPdf(e)}
            >
              {form.document.replace("./documents/", "")}
            </a>
          ) : (
            ""
          )}
        </div>
        <div style={{ textAlign: "center" }}>
          <Button
            variant="contained"
            onClick={handleClose}
            style={{ margin: 20 }}
            size="large"
            color="error"
          >
            Anulează
          </Button>
          <Button
            variant="contained"
            type="submit"
            style={{ margin: 20 }}
            size="large"
          >
            Salvează
          </Button>
        </div>
      </ValidatorForm>
      {activeImage ? (
        <Modal
          open={true}
          onClose={() => setActiveImage(null)}
          aria-labelledby="image-modal"
          aria-describedby="image-modal"
          style={{
            padding: 10,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Fade in={true}>
            <Paper
              style={{
                padding: 10,
                maxWidth: 600,
                "& img": {
                  maxWidth: "100%",
                },
              }}
            >
              <img src={activeImage} alt={activeImage} />
            </Paper>
          </Fade>
        </Modal>
      ) : null}
    </Dialog>
  );
}
export default FormsModal;
FormsModal.propTypes = {
  form: PropTypes.object,
  open: PropTypes.bool,
  setForm: PropTypes.func,
  handleClose: PropTypes.func,
  handleSubmit: PropTypes.func,
};
